export const flattenResourceByKey = <
  K extends string,
  T extends Partial<Record<K, T | null>>,
>(
  resource: T,
  key: K,
): T[] => {
  const child = resource[key];
  return [resource].concat(child ? flattenResourceByKey(child, key) : []);
};
